import { useEffect } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import { advencedKitBuyNow } from '../utils/constant';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/pc/');

export default function G(): JSX.Element {
    const { useLang, Link, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const itemListMap: any = {
        us: [
            {
                name: t('secG_item1_title1'),
                features: [t('secG_item1_feature_1'), t('secG_item1_feature_2'), t('secG_item1_feature_3'), t('secG_item1_feature_4')],
                img: 'g-5',
                link: 'https://us.ecoflow.com/products/delta-pro-double-voltage-hub',
            },
            {
                name: t('secG_item2_title1'),
                features: [t('secG_item2_feature_1'), t('secG_item2_feature_2'), t('secG_item2_feature_3')],
                img: 'g-3',
                link: 'https://us.ecoflow.com/products/delta-pro-double-voltage-hub?variant=40435773866057',
            },
            {
                name: t('secG_item3_title1'),
                features: [t('secG_item3_feature_1'), t('secG_item3_feature_2'), t('secG_item3_feature_3')],
                img: 'g-4',
                link: 'https://us.ecoflow.com/products/delta-pro-double-voltage-hub?variant=40435774390345',
            },
        ],
        ca: [
            {
                name: t('secG_item1_title1'),
                features: [t('secG_item1_feature_1'), t('secG_item1_feature_2'), t('secG_item1_feature_3'), t('secG_item1_feature_4')],
                img: 'g-5',
                link: 'https://ca.ecoflow.com/products/delta-pro-double-voltage-hub',
            },
            {
                name: t('secG_item2_title1'),
                features: [t('secG_item2_feature_1'), t('secG_item2_feature_2'), t('secG_item2_feature_3')],
                img: 'g-3',
                link: 'https://ca.ecoflow.com/products/delta-pro-double-voltage-hub?variant=43246000767130',
            },
            {
                name: t('secG_item3_title1'),
                features: [t('secG_item3_feature_1'), t('secG_item3_feature_2'), t('secG_item3_feature_3')],
                img: 'g-4',
                link: 'https://ca.ecoflow.com/products/delta-pro-double-voltage-hub?variant=43246000799898',
            },
        ],
    };

    const itemList = itemListMap[locale] || itemListMap.us;

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.landing_page_G',
            triggerHook: 1,
            offset: layoutH + 200,
        })
            .setClassToggle('.landing_page_G', 'show')
            .addTo(aniController);

        createScene({
            triggerElement: '.landing_page_G',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.landing_page_G_wrapper', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    const handleBuyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('secG_pro_name'),
                position: `Solution Page_${t('secG_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
    };

    const handleBuyNow2 = (item: any) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: item.name,
                position: `Solution Page_${t('secE_item2_title_1')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className={`landing_page_G ${css.landing_page_G}`}>
            <div className="landing_page_G_wrapper">
                <div className="pageG_1">
                    <div className="page_J_right">
                        <EFPic name={['g-1.webp', 'g-1.jpg']} />
                    </div>
                    <div className="page_J_left">
                        <div className="leftContentBox">
                            <div className="secJ_title">{t('secG_title')}</div>
                            <div className="secJ_pro_name">{t('secG_pro_name')}</div>
                            <div className="secJ_pro_paramBox">
                                <div className="secJ_pro_param">{t('secG_pro_param_1')}</div>
                                <div className="secJ_pro_param">{t('secG_pro_param_2')}</div>
                                <div className="secJ_pro_param">{t('secG_pro_param_3')}</div>
                                <div className="secJ_pro_param">{t('secG_pro_param_4')}</div>
                            </div>
                            <div className="secJ_pro_desc">{t('secG_pro_desc')}</div>
                            <Link href={advencedKitBuyNow.replace('//us.', `//${locale}.`)} target="blank">
                                <div className="secJButton btnHover" onClick={handleBuyNow}>
                                    {t('secG_buyNow')}
                                </div>
                            </Link>
                            <div className="secJ_tip">{t('secG_tip')}</div>
                        </div>
                    </div>
                </div>
                <div className="pageG_2">
                    <div className="pageG_2_box">
                        {itemList.map((item: any, index: number) => (
                            <div className="listItem" key={index}>
                                <div className="listItemImg">
                                    <EFPic name={[`${item.img}.webp`, `${item.img}.png`]} />
                                </div>
                                <div className="listItemInfo">
                                    <div className="listItemName">{item.name}</div>
                                    <div className="listItemFeatureBox">
                                        {item.features.map((feature: string, fIndex: number) => (
                                            <div className="listItemFeature" key={fIndex}>
                                                {feature}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <Link href={item.link} target="blank">
                                    <div className="listItemButton btnHover" onClick={() => handleBuyNow2(item)}>
                                        {t('secG_buyNow')}
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
